import { useContext, useEffect, useCallback } from 'react';
import { BroadcastContext } from '../utils/BroadcastProvider.js';

export const useSubscribe = (eventName, callback, deps) => {
  const { subscribe } = useContext(BroadcastContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handler = useCallback(callback, deps ?? []);

  useEffect(() => {
    if (subscribe) {
        const unsubscribe = subscribe(eventName, handler);

        // Cleanup subscription on unmount
        return unsubscribe;
    }
  }, [eventName, handler, subscribe]);
};

export const useSubscribeAll = (callback, deps) => {
  const { subscribeAll } = useContext(BroadcastContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handler = useCallback(callback, deps ?? []);

  useEffect(() => {
    if (subscribeAll) {
        const unsubscribe = subscribeAll(handler);

        // Cleanup subscription on unmount
        return unsubscribe;
    }
  }, [handler, subscribeAll]);
}

export const useBroadcast = () => {
    const { broadcast } = useContext(BroadcastContext);
    return broadcast;
}

export const useWindowOpener = () => {
  const { opener } = useContext(BroadcastContext);
  return opener
}

export const usePopout = () => {
  const { popout } = useContext(BroadcastContext);
  return popout
}